import { FaBook } from "react-icons/fa6";
import { BASE_FRONT_END_URL } from "../../../../utils/appConstant";

// interface BookProps {
//   citation: string | any; // can be string or object
//   // isLoading?: boolean;
//   chapter
  
// }

interface BookProps {
  citation: {
    citation: string;
    title: string;
    link: string;
    book_name?: string; 
    chapter?:string;
    
  };
  onCitationClick?: (citation: any) => void;
}
function BookCitations({ citation, onCitationClick }: BookProps) {
  const curatedBookName = citation.book_name;
  citation.chapter
  function onCitationClicked(citations: any): void {
    if (onCitationClick) {
      onCitationClick(citations);
    }
  }
  return (
    <div>

        <a
        target="_blank"
        rel="noopener noreferrer"
        href={BASE_FRONT_END_URL + "book/" + citation.book_name +"/" + citation.title}
        className="cursor-pointer text-blue-600 hover:underline"
    >

        {curatedBookName} - {citation.title} &nbsp;
        <FaBook className="inline" title="Book" />
      </a>
    </div>
  );
}

export default BookCitations;
